module.exports = __webpack_public_path__ + "img/bg_home_patient_info.412ee3bb.png";